import React from 'react';

// Components
import PrivacyPolicy from '../../shared/PrivacyPolicy';

function Privacy() {
  return (
    <div className='AdminWrapper'>
      <h2 className='u-mb1'>Curbside Provisions Privacy Policy</h2>
      <PrivacyPolicy/>
    </div>
  );
}

export default Privacy;
